import Facturas from "../components/bussines/ventas/facturas";
import Notacredito from '../components/bussines/ventas/notasCredito';
import Notadebito from '../components/bussines/ventas/notasDebito';
import Pedidos from '../components/bussines/pedidos/pedidos';
import Reportepedidos from '../components/bussines/pedidos/reportepedidos';
import PedidosMovil from '../components/bussines/pedidos/pedidosMovil';
import DocumentoSoporte from '../components/bussines/ventas/documentoSoporte';
import Clientes from '../components/bussines/catalogos/clientes';
import ReporteAcuse from '../components/factlectronica/reporteAcuse';
import ReporteEmpresas from '../components/factlectronica/reporteEmpresas';
import ReporteDetallado from '../components/factlectronica/ReporteDetallado';
import ReporteSalto from '../components/reportes/reporteSalto';
import Gestiones from '../components/factlectronica/gestiones';
import Impresion from '../components/factlectronica/impresion';
import Post from '../components/bussines/ventas/post';
import Turnos from '../components/bussines/ventas/turnos';
import ImpresionPos from '../components/bussines/ventas/impresionPos';
import ReporteVentas from '../components/bussines/ventas/reporteVentas';
import ReporteDocumentos from '../components/bussines/ventas/reporteDocumentos';
import Empleados from '../components/nomina/empleados';
import GestionNomina from '../components/nomina/gestionesNomina';
import ReporteNomina from '../components/factlectronica/reporteNomina';
import ReporteDetalladoNomina from '../components/nomina/ReporteDetallado';
import ReporteDetalleNomina from '../components/nomina/ReporteDetalleNomina';
import HomologacionNomina from '../components/nomina/homologacion';
import GestionesEmpleados from '../components/nomina/gestionesNominaEmpleados';
import ReporteConsolidadoEmp from '../components/nomina/ReportConsolidadoEmp';
import PagoNomina from '../components/nomina/formularioPagoNomina';
import IngresoInventario from '../components/bussines/inventarios/ingresoInventario';
import Bodegas from '../components/bussines/inventarios/bodegas';
import AjusteInventario from '../components/bussines/inventarios/ajusteInventario';
import TransladoInventario from '../components/bussines/inventarios/transladoInventario';
import ReporteExitencia from '../components/bussines/inventarios/reporteExitencia';
import ReporteMovimiento from '../components/bussines/inventarios/reporteMovimiento';
import Formapago from '../components/bussines/catalogos/formaspago';
import Impuestos from '../components/bussines/catalogos/impuestos';
import Retenciones from '../components/bussines/catalogos/retenciones';
import Servicios from '../components/bussines/catalogos/itemServicios';
import Listaprecio from '../components/bussines/catalogos/listaPrecios';
import Vendedores from '../components/bussines/catalogos/vendedores';
import Unidadmedida from '../components/bussines/catalogos/unidadmedida';
import Metodospago from '../components/bussines/catalogos/metodospago';
import TiposInventario from '../components/bussines/catalogos/tipoInventario';
import GrupoInventario from '../components/bussines/catalogos/grupoInventario';
import LineasInventario from '../components/bussines/catalogos/lineasInventario';
import ClientesCarga from '../components/bussines/cargacatalogos/clientes';
import ItemsCarga from '../components/bussines/cargacatalogos/items';
import PreciosCarga from '../components/bussines/cargacatalogos/precios';
import CodigoBarra from '../components/bussines/catalogos/codigoBarraitem';
import Descuentos from '../components/bussines/catalogos/descuentos';
import Usuarios from '../components/configuracion/usuarios';
import IngresosUsuarios from '../components/configuracion/ingresosUsuarios';
import Resoluciones from '../components/configuracion/resoluciones';
import Parametros from '../components/nomina/formularioParametros';
import Email from '../components/configuracion/configMail';
import FormularioEmpresa from '../components/configuracion/formularioEmpresa';
import generadorPlano from '../components/bussines/pedidos/generadorPlano';
import ConvetidorFacturas from '../components/bussines/pedidos/convertidorFacturas';
import RecibosCaja from '../components/bussines/cartera/recibosCaja';
import ReporteCartera from '../components/bussines/cartera/reporteCartera';
import ReporteRecibos from '../components/bussines/cartera/reporteRecibos';
import AprobadorPedidos from '../components/bussines/pedidos/aprobadorPedidos';
import cargaTerceros from "../components/archivos/cargaTerceros";
import cargaPrecios from "../components/archivos/cargaPrecios";

// Diccionario de componentes
export const componentDictionary = {
  facturas: Facturas,
  notasc: Notacredito,
  notasd: Notadebito,
  documentosoporte: DocumentoSoporte,
  pedidos: Pedidos,
  pedidosmovil: PedidosMovil,
  gestion: Gestiones,
  prefacturas: Impresion,
  clientes: Clientes,
  acuse: ReporteAcuse,
  reporteempresas: ReporteEmpresas,
  reportedetalladofe: ReporteDetallado,
  saltoreporte: ReporteSalto,
  factpost:Post,
  imppos:ImpresionPos,
  turnos:Turnos,
  rventaspos:ReporteVentas,
  rdocpos:ReporteDocumentos,
  empleados: Empleados,
  homologacion: HomologacionNomina,
  pagonomina: PagoNomina,
  gestionNomina: GestionNomina,
  gestionnominaemp: GestionesEmpleados,
  reportenomina: ReporteNomina,
  reportenominaemp: ReporteConsolidadoEmp,
  reportedetalladonomina: ReporteDetalladoNomina,
  reportedetallenomina: ReporteDetalleNomina,
  bodegas: Bodegas,
  ingresoinventario: IngresoInventario,
  ajusteinventario: AjusteInventario,
  transladoinventario: TransladoInventario,
  rexistenciainv: ReporteExitencia,
  rmovimientoinv: ReporteMovimiento,
  servicios:Servicios,
  barras:CodigoBarra,
  listaprecio:Listaprecio,
  descuentos:Descuentos,
  formapago:Formapago,
  metodos:Metodospago,
  tipoinventario:TiposInventario,
  grupoinventario:GrupoInventario,
  lineasinventario:LineasInventario,
  retenciones:Retenciones,
  impuestos:Impuestos,
  unidades:Unidadmedida,
  vendedores:Vendedores,
  cargaclientes:ClientesCarga,
  cargaitems:ItemsCarga,
  cargaprecios:PreciosCarga,
  usuarios: Usuarios,
  ingresos: IngresosUsuarios,
  parametros: Parametros,
  email: Email,
  resoluciones: Resoluciones,
  empresacrear:FormularioEmpresa,
  generarplanopedidos: generadorPlano,
  convertidorpedfac: ConvetidorFacturas,
  aprobarpedidos: AprobadorPedidos,
  reportepedidos: Reportepedidos,
  reciboscaja: RecibosCaja,
  reportecartera: ReporteCartera,
  reporterecibos: ReporteRecibos,
  cgunoterceros: cargaTerceros,
  cgunoprecios: cargaPrecios,
};


// WEBPACK FOOTER //
// ./src/middleware/componentDictionary.js